import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer"

export default function Engineering() {

    // Click and scroll
    function handleClick(elementId) {
        const scrollElement = document.getElementById(elementId)
        scrollElement.scrollIntoView({behavior: "smooth"});
        // setTimeout(function () {
        //     scrollElement.scrollIntoView({behavior: "smooth"});
        // }, 100);
        console.log(elementId)
    }

    return (
        <div className="flex flex-col h-lvh">

            {/* Header */}
            <Navbar/>

            {/* Sidebar turns into subheader in mobile device */}
            <div className="inset-x-0 bg-white border-b px-4 sm:px-6 md:px-8 lg:hidden">
                <div className="flex items-center py-4">
                    <button type="button" className="text-gray-500 hover:text-gray-600"
                            data-hs-overlay="#description-sidebar" aria-controls="description-sidebar"
                            aria-label="Toggle navigation">
                        <span className="sr-only">Toggle Navigation</span>
                        <svg className="size-5" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path fillRule="evenodd"
                                  d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </button>
                    <ol className="ms-3 flex items-center whitespace-nowrap">
                        <li className="flex items-center text-sm text-gray-800">
                            Project
                            <svg
                                className="flex-shrink-0 mx-3 overflow-visible size-2.5 text-gray-400"
                                width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14"
                                      stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </li>
                        <li className="text-sm font-semibold text-gray-800 truncate">
                            Engineering
                        </li>
                    </ol>
                </div>
            </div>

            {/* Main Content */}
            <div className="lg:flex grow max-w-[85rem] w-full mx-auto">

                {/* Sidebar with accordion */}
                <div id="description-sidebar"
                     className="max-h-svh hs-overlay hs-overlay-open:translate-x-0 -translate-x-full transition-all duration-300 transform hidden fixed top-0 start-0 bottom-0 z-20 w-72 sm:w-[36rem] bg-white border-e border-gray-200 pt-7 overflow-y-auto lg:static lg:block lg:translate-x-0 lg:end-auto lg:bottom-0 ">
                    <div className="px-6">
                        <div className="flex-none text-xl font-semibold px-1">
                            Engineering
                        </div>
                    </div>

                    <nav className="p-6 w-full flex flex-col flex-wrap">
                        <ul className="space-y-1.5">
                            <li>
                                <div onClick={() => handleClick("Engineering-1")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Overview
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Engineering-2")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Cycle 1
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Engineering-2-1")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Design
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Engineering-2-2")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Build
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Engineering-2-3")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Test
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Engineering-2-4")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Learn
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Engineering-3")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Cycle 2
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Engineering-3-1")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Design
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Engineering-3-2")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Build
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Engineering-3-3")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Test
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Engineering-3-4")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Learn
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Engineering-4")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block"></span>
                                    References
                                </div>
                            </li>

                        </ul>
                    </nav>
                </div>

                {/* Major text sections */}
                <div className="max-h-svh overflow-y-auto w-full px-4 sm:px-6 md:px-24 lg:px-32">
                    <div>
                        <div id="Engineering-1" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Overview
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                The aim of the project was to produce guanine crystals, commonly used for their
                                iridescent effect in various cosmetic products, recombinantly in BL21 Escherichia coli.
                                To do so, we aimed to transform E.coli with two plasmids; one containing relevant genes
                                to boost guanine production, the other containing a CRISPRi system designed to inhibit
                                guanine degradation. While crystals are yet to be observed, we are continuously
                                employing the principles of the engineering cycle to (re-) design, build, test and
                                learn from previous sprints to improve the workflow of this project.
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Engineering-2" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Cycle 1
                        </div>
                        <div id="Engineering-2-1" className="text-xl font-bold text-gray-800 sm:text-2xl mt-6">
                            Design
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                Construct designed in the first cycle aimed to boost production of guanine (GMP),
                                It contained the genes GuaA and GuaB under the T7 promoter. These genes code the
                                two enzymes (GMP synthetase and IMP dehydrogenase) that are involved in guanine
                                synthesis pathway (Image 1) in bacteria. We hypothesised that GuaA and GuaB
                                overexpression would lead to higher guanine production rate and thus more substrate
                                for crystal formation. Additionally, the gene AeBlue was added to the construct to
                                verify successful transformation and induction of the plasmid. BL21 E. coli was
                                chosen as the host organism for our experiments due to well-established cultivation
                                and transformation protocols.
                            </div>
                            <img
                                src="https://static.igem.wiki/teams/5122/engineering/engineering-1.png"
                                className="w-full mt-5"
                                alt=""
                            />
                            <div className="mt-5 text-center">
                                Image 1: Guanine synthesis pathway (from Jewett et al., 2009 J Bacteriol) (1)
                            </div>
                        </div>
                        <div id="Engineering-2-2" className="text-xl font-bold text-gray-800 sm:text-2xl mt-6">
                            Build
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                The pET45 plasmid backbone was amplified in TOP10 E. coli. The GuaA, GuaB and AeBlue
                                containing insert was amplified by means of PCR using Phusion polymerase with a
                                proof-reading activity. The length of the backbone and the  amplicon was verified
                                using gel electrophoresis. Next, DNA fragments of proper size were cut out from the
                                gel and purified using a commercial gel extraction kit. Plasmid and insert were digested
                                with SacI and HindIII restriction enzymes and ligated using T4 ligase according to
                                enzyme supplier protocols. After the ligation, restriction digest was performed to
                                verify the success of the protocols. Thereafter, the BL21 E. Coli was transformed
                                with the construct.
                            </div>
                        </div>
                        <div id="Engineering-2-3" className="text-xl font-bold text-gray-800 sm:text-2xl mt-6">
                            Test
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                Transformed BL21 cells were grown to OD 0.6 (at 37 °C) in a liquid culture and
                                then induced with IPTG. The cultures were grown in the presence of IPTG, at RT
                                for 24 h in a liquid culture and also of IPTG+ agars. Samples from the liquid
                                cultures were drawn at 2, 6 and 18 h post- IPTG induction in order to check for
                                guanine concentration changes using Guanine Detection Kit and relative protein
                                expression levels using SDS page of the sonicated bacterial lysates. Agar cultures
                                were left to grow for a long time, since the formation of guanine crystals takes
                                weeks in bacteria (2).
                            </div>
                        </div>
                        <div id="Engineering-2-4" className="text-xl font-bold text-gray-800 sm:text-2xl mt-6">
                            Learn
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                Despite good culture growth and seemingly successful cloning steps, we did not
                                observe AeBlue+ / blue color of our liquid culture nor of the colonies. As for the
                                SDS-PAGE results, thicker bands of for GuaA (58,665 Da) and GuaB (52,022 Da) proteins
                                were observed in the IPTG-induced lysates (as compared to the uninduced control
                                lysates) but no band corresponding to AeBlue chromoprotein (25 900 Da) was observed.
                                Thus, we went back to the construct design to revise the genetic components
                                placement, inter-gene regions design and orientations on the genes. We have also
                                isolated the plasmid and sent it for sequencing in order to gain assurance in the
                                construct integrity.
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Engineering-3" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Cycle 2
                        </div>
                        <div id="Engineering-3-1" className="text-xl font-bold text-gray-800 sm:text-2xl mt-6">
                            Design
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                The second construct was created to silence the gene (GuaD) that codes guanine
                                degrading enzyme - guanine deaminase. For this pET45 was used again. Expression of
                                dead Cas9 enzyme was under T7 promoter. Single-guide RNA (sgRNA) that targets
                                specific DNA sequence in the guaD gene was designed and incorporated into the
                                plasmid. The system was encoded  by one plasmid containing Cas9 and sgRNA together.
                                In case of successful GuaD inhibition (in addition to guanine overproduction)
                                we hoped to achieve high guanine concentrations in the cell and its subsequent
                                build up into crystals as it is observed in various Aeromonas spp. Bacteria (Image 2)
                                lacking GuaD gene (2).
                            </div>
                            <img
                                src="https://static.igem.wiki/teams/5122/engineering/engineering-2.png"
                                className="w-full mt-5"
                                alt=""
                            />
                            <div className="mt-5 text-center">
                                Image 2: Bacterial species lacking guaD and xdh genes, capable of guanine
                                crystal production (2).
                            </div>
                        </div>
                        <div id="Engineering-3-2" className="text-xl font-bold text-gray-800 sm:text-2xl mt-6">
                            Build
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                Transformation of the plasmid with the guaD silencing construct would be performed
                                as described in the cycle 1 (according to the same protocols, using the same
                                bacterial strain). After transformation we would send the selected clones for
                                sequencing in order to verify the sequence integrity.
                            </div>
                        </div>
                        <div id="Engineering-3-3" className="text-xl font-bold text-gray-800 sm:text-2xl mt-6">
                            Test
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                Real-time qPCR for the guaD gene would be the first measure to confirm silencing
                                success on the transcription level. Secondly, SDS-PAGE would be done in order to
                                confirm the result on the protein level (GuaD product = 50,244 Da). Additionally,
                                Guanine Detection Kit could be used to compare the guanine concentration in the
                                normal BL21 E.coli culture, GuaA and GuaB expressing culture and GuaD-silenced cultures.
                            </div>
                        </div>
                        <div id="Engineering-3-4" className="text-xl font-bold text-gray-800 sm:text-2xl mt-6">
                            Learn
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                Due to a low GC-content, the provider was unable to synthesise the insert. Therefore,
                                we decided to redirect focus on revising the insert via codon optimization,
                                specifically to insert GC-saturated spacers to amplify the overall GC-content.
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Engineering-4" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            References
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <ol className="list-decimal space-y-4 pl-5">
                                <li>
                                    JEWETT MW, LAWRENCE KA, BESTOR A, BYRAM R, GHERARDINI F, ROSA PA. GuaA and GuaB
                                    Are Essential for Borrelia burgdorferi Survival in the Tick-Mouse Infection Cycle.
                                    Journal of Bacteriology. 2009;191:6231–41.
                                </li>
                                <li>
                                    Pavan ME, Movilla F, Pavan EE, Di Salvo F, López NI, Pettinari MJ. Guanine
                                    crystal formation by bacteria. BMC biology. 2023;21:66–66.
                                </li>
                            </ol>
                        </div>
                    </div>

                    <div className="h-16"></div>
                </div>
            </div>

            {/* Footer */}
            <Footer />
        </div>
    )
}